<template>

  <v-card>
    <v-card-title primary-title>
      <slot name="heading">
      {{ heading }}
      </slot>
    </v-card-title>

    <v-card-text>
      <slot></slot>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <slot name="actions">
        <v-btn text @click="$emit('ok')">{{ $t(ok) }}</v-btn>
        <v-btn text @click="$emit('cancel')">{{ $t(cancel) }}</v-btn>
      </slot>
    </v-card-actions>
  </v-card>

</template>

<script>
  export default {
    name: 'ob-dialog',

    props: {
      heading: {
        type: String
      },
      ok: {
        type: String,
        default: 'ok'
      },
      cancel: {
        type: String,
        default: 'cancel'
      }
    }
  }
</script>

<style scoped lang="scss">

</style>
